export const FileType = {
  // Zip: ['application/zip', 'application/octet-stream', 'application/x-zip-compressed', 'multipart/x-zip'],
  // Txt: ['text/plain'],
  // Excel: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'],
  // CSV: ['text/csv', '.csv'],
  // PDF: ['application/pdf'],
  // Ret: ['application/octet-stream'],
  // P7s: ['application/pkcs7-signature'],
  // XLSX: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
  // XLS: ['application/vnd.ms-excel'],
  // DOC: ['application/msword'],
  // DOCX: ['application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
  // MSG: ['application/vnd.ms-outlook', 'application/octet-stream', '.msg'],
  // PST: ['application/vnd.ms-outlook', 'application/octet-stream'],
  // JPEG: ['image/jpeg'],
  // JPG: ['image/jpeg'],
  // PNG: ['image/png'],
  // EML: ['message/rfc822']

  Zip: ['.zip', '.octet-stream', '.x-zip-compressed', '.multipart/x-zip'],
  Txt: ['.txt'],
  Excel: ['.xlsx', '.xls'],
  CSV: ['.csv'],
  PDF: ['.pdf'],
  Ret: ['.octet-stream'],
  P7s: ['.p7s'],
  XLSX: ['.xlsx'],
  XLS: ['.xls'],
  DOC: ['.doc'],
  DOCX: ['.docx'],
  MSG: ['.msg'],
  PST: ['.pst'],
  JPEG: ['.jpeg'],
  JPG: ['.jpg'],
  PNG: ['.png'],
  EML: ['.eml']
};

/** Limite de upload no cliente. O nginx na frente da API também precisa permitir esse tamanho (`client_max_body_size`). */
export const MAX_UPLOAD_FILE_SIZE_MB = 10;
export const MAX_UPLOAD_FILE_SIZE_BYTES = MAX_UPLOAD_FILE_SIZE_MB * 1024 * 1024;
